// src/api/axiosClient.ts
import type { AxiosInstance } from "axios";
import type { AxiosError } from "axios";
import { createAxiosInstance } from "host/createAxios";
import { handleUnauthorized } from "host/axiosHostHandlers";
import router from "@Router/index";

// Set once during setupRuntime()
export let axios!: AxiosInstance;
export let axiosAuth!: AxiosInstance;

function handleApiError(error: AxiosError): void {
  // Redirect to error page for any 500 API errors 
  // TODO - Revisit if we need to handle other status codes except 401 which is handled by onUnauthorized
  const status = error?.response?.status;
  if (status === 500) {
    try {
      // Don't redirect if already on the error page to avoid loops
      const currentRoute = router.currentRoute.value;
      if (currentRoute && currentRoute.name === 'error') {
        return;
      }

      console.error('[Esign MFE] API Error caught, redirecting to error page:', error);
      router.push({ name: 'error' }).catch((err) => {
        // Ignore navigation errors (e.g., if already navigating)
        console.warn('[Esign MFE] Navigation error:', err);
      });
    } catch (routerError) {
      // If router is not ready, log the error but don't crash
      console.error('[Esign MFE] API Error caught, but router is not ready:', error, routerError);
    }
  }
}

export function initAxios(baseURL: string): AxiosInstance {
  axios = createAxiosInstance({
    baseURL,
    hooks: { 
      onUnauthorized: handleUnauthorized,
      onError: handleApiError,
    },
  });

  return axios;
}

// Not used as of December 2025. If we need it in the future, revisit onError.
export function initAuthAxios(baseURL: string): AxiosInstance {
  console.log(baseURL);
  axiosAuth = createAxiosInstance({
    baseURL,
    hooks: { onUnauthorized: handleUnauthorized },
  });

  return axiosAuth;
}
